import { render } from "./ScreenshotsTab.vue?vue&type=template&id=0aadf512&scoped=true"
import script from "./ScreenshotsTab.vue?vue&type=script&lang=js"
export * from "./ScreenshotsTab.vue?vue&type=script&lang=js"

import "./ScreenshotsTab.vue?vue&type=style&index=0&id=0aadf512&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aadf512"]])

export default __exports__